import EfficiencyClassIcon from './efficiency-class-icon'

export const AmuiEfficiencyClassIcon = EfficiencyClassIcon

export default Vue =>
  Vue.component(EfficiencyClassIcon.name, EfficiencyClassIcon)
